import { GA4Logger } from '@zep/analytics';
import {
  HyperdxLogger,
  registerLogger,
  SentryLogger,
  ZettaLogger,
} from '@zep/core-logger';
import { ZEPLogger } from '@zep/logger';

import { getInitialQuizTrackingState } from '../trackingContext';

import {
  ga4Dispatch,
  hyperdxLoggerConfig,
  Sentry,
  zettaClient,
} from './config';
import { GtmMarketingEventLogger } from './GtmMarketingEventLogger';

const zettaLogger = new ZettaLogger(zettaClient);
const ga4Logger = new GA4Logger({
  dispatch: ga4Dispatch,
});
const gtmMarketingEventLogger = new GtmMarketingEventLogger();

const hyperdxLogger = new HyperdxLogger(hyperdxLoggerConfig);
const sentryLogger = new SentryLogger(Sentry);

const appLogger = new ZEPLogger({
  loggers: [
    zettaLogger,
    ga4Logger,
    gtmMarketingEventLogger,
    hyperdxLogger,
    sentryLogger,
  ],
  initialState: {
    zep_service_name: 'zep-quiz',
    zep_deployment_env: process.env.NEXT_PUBLIC_STAGE,
    deploymentCommitId: process.env.NEXT_PUBLIC_COMMIT_SHA,
    // ZEP-591 카나리 버킷 구분 ('eks' | 'vercel', next.config 가 빌드타임 인라인).
    // ServiceName 프리픽스(SERVER_NAME)는 슬롯 이름이라 버킷 구분자로 쓰면 안 된다 —
    // dev-1 양쪽 이름이 통일되는 순간 사라지는 우연한 구분이었다.
    zep_deployment_origin: process.env.NEXT_PUBLIC_DEPLOYMENT_ORIGIN,
    ...getInitialQuizTrackingState(),
  },
});
registerLogger(appLogger);
